import { prefixObjectValues } from '../utils';

const typeAndCategory = {
  title: 'title',
  browseFiles: 'browse-files-button',
  nextButton: 'next-button',
  backButton: 'back-button',
  loadingBar: 'loading-bar',
  docTypeCvButton: 'doc-type-cv-button',
  docTypePacketButton: 'doc-type-packet-button',
  uploadCard: 'upload-card',
  dropzone: 'dropzone',
};

export default prefixObjectValues(typeAndCategory, 'registration-cv-upload');
